// extracted by mini-css-extract-plugin
export default {"root":"loading-module--root--ayZ83","pulse":"loading-module--pulse--b5xMO"};